import React, { useState, useRef, useEffect } from 'react';
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';
import IconButton from '@mui/material/IconButton';
import BackupIcon from '@mui/icons-material/Backup';
import Typography from '@mui/material/Typography';
import CancelIcon from '@mui/icons-material/Cancel'; // Add Cancel Icon
import { db, storage, firestore } from '../../MY_LOGIN_AND_SIGNUP/db/config';

const ViewQuestionModal = ({ question, isOpen, toggleModal }) => {
  console.log('View Question:', question);

  const [removableOptions, setRemovableOptions] = useState(new Set());
  const [optionImages, setOptionImages] = useState({});
  const [questionImage, setQuestionImage] = useState(''); // State for the question image
  const [imageError, setImageError] = useState(''); // To store validation error messages
  const secondaryBrowseBtnRef = useRef({});
  const questionBrowseBtnRef = useRef();
  console.log(optionImages, 'optionImages');
  const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB

  const handleImageUpload = (event, optionKey) => {
    const file = event.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        setImageError('Please select a valid image file.');
        return;
      }

      if (file.size > MAX_FILE_SIZE) {
        setImageError('File size exceeds 2MB limit.');
        return;
      }

      setImageError(''); // Clear error message if file is valid
      setOptionImages((prev) => ({
        ...prev,
        [optionKey]: URL.createObjectURL(file), // Preview image
      }));
    }
  };

  useEffect(() => {
    const fetchImages = async () => {
      if (question?.id) {
        const imagesCollection = firestore
          .collection('QuestionsV2')
          .doc(question.id)
          .collection('Images');

        const snapshot = await imagesCollection.get();
        snapshot.forEach((doc) => {
          const data = doc.data();
          if (data.imageFor === 'question') {
            setQuestionImage(
              `https://firebasestorage.googleapis.com/v0/b/tn-edu.appspot.com/o/${encodeURIComponent(
                data.imagePath
              )}?alt=media`
            ); // Fetch question image
          } else if (
            ['optionA', 'optionB', 'optionC', 'optionD'].includes(data.imageFor)
          ) {
            console.log(data);
            setOptionImages((prev) => ({
              ...prev,
              [data.imageFor]: `https://firebasestorage.googleapis.com/v0/b/tn-edu.appspot.com/o/${encodeURIComponent(
                data.imagePath
              )}?alt=media`,
            }));
          }
        });
      }
    };

    fetchImages();
  }, [question?.id]);

  const handleQuestionImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        setImageError('Please select a valid image file.');
        return;
      }

      if (file.size > MAX_FILE_SIZE) {
        setImageError('File size exceeds 2MB limit.');
        return;
      }

      setImageError(''); // Clear error message if file is valid
      setQuestionImage(URL.createObjectURL(file)); // Preview image for question
    }
  };

  const handleRemoveImage = (optionKey) => {
    console.log('optionKey', optionKey);
    setOptionImages((prev) => {
      const updatedImages = { ...prev };
      delete updatedImages[optionKey];
      return updatedImages;
    });
    setRemovableOptions((prev) => new Set(prev).add(optionKey));
  };

  const handleRemoveQuestionImage = () => {
    setQuestionImage('');
  };

  const handleSubmit = async (questionId) => {
    console.log(optionImages, questionImage, 'image checking', questionId);

    try {
      const uploadImageToFirebase = async (image, path) => {
        if (!image) return null;

        const response = await fetch(image);
        const blob = await response.blob();

        const storageRef = storage.ref().child(path);
        const snapshot = await storageRef.put(blob);

        const fullUrl = await snapshot.ref.getDownloadURL();
        console.log('Image uploaded successfully:', fullUrl);

        return snapshot.metadata.fullPath;
      };

      const firestoreRef = firestore.collection('QuestionsV2').doc(questionId);
      const imagesCollection = firestoreRef.collection('Images');

      for (let optionKey of removableOptions) {
        await imagesCollection
          .where('imageFor', '==', optionKey)
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) => doc.ref.delete());
          });
      }

      const getExistingImageDocId = async (imageFor) => {
        const snapshot = await imagesCollection
          .where('imageFor', '==', imageFor)
          .get();
        if (!snapshot.empty) {
          return snapshot.docs[0].id;
        }
        return null;
      };

      // Upload and update the Question Image
      const existingImageDocId = await getExistingImageDocId('question');

      if (questionImage) {
        const questionImagePath = await uploadImageToFirebase(
          questionImage,
          `question_images/${Date.now()}`
        );

        if (questionImagePath) {
          if (existingImageDocId) {
            await imagesCollection.doc(existingImageDocId).update({
              imagePath: questionImagePath,
              createdAt: new Date(),
            });
          } else {
            await imagesCollection.add({
              imageFor: 'question',
              imagePath: questionImagePath,
              createdAt: new Date(),
            });
          }
        }
      } else if (existingImageDocId) {
        // Remove existing image document if questionImage is empty
        await imagesCollection.doc(existingImageDocId).delete();
      }

      // Upload and update Option Images (A, B, C, D)
      await Promise.all(
        Object.keys(optionImages).map(async (key) => {
          const optionImagePath = await uploadImageToFirebase(
            optionImages[key],
            `option_images/${key}_${Date.now()}`
          );

          if (optionImagePath) {
            const existingImageDocId = await getExistingImageDocId(key);
            if (existingImageDocId) {
              await imagesCollection.doc(existingImageDocId).update({
                imagePath: optionImagePath,
                createdAt: new Date(),
              });
            } else {
              await imagesCollection.add({
                imageFor: key,
                imagePath: optionImagePath,
                createdAt: new Date(),
              });
            }
          }
        })
      );

      alert('Options and images uploaded successfully!');
      toggleModal();
    } catch (error) {
      console.error('Error uploading images:', error);
      alert('An error occurred while uploading images.');
    }
  };


  const inputStyle = {
    backgroundColor: '#2c2f47',
    color: '#fff',
    border: '1px solid #5a5e75',
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggleModal}
      size='lg'
      style={{
        transform: 'translateY(0)',
      }}
    >
      <div
        style={{
          backgroundColor: 'rgb(39, 41, 61)',
          padding: '10px 15px',
          color: '#fff',
          fontSize: '18px',
          fontWeight: 'bold',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        View Question
        <button
          type='button'
          className='close'
          onClick={toggleModal}
          style={{
            color: '#fff',
            fontSize: '24px',
            border: 'none',
            background: 'none',
            cursor: 'pointer',
          }}
        >
          &times;
        </button>
      </div>

      <ModalBody
        style={{
          backgroundColor: 'rgb(39, 41, 61)',
          paddingTop: '20px',
          transform: 'translateY(0)',
          height: '71.5vh',
          overflowY: 'auto'
        }}
      >
        {/* Question Details */}

        <FormGroup>
          <Label style={{ color: '#fff' }}>Subject</Label>
          <Input
            type='text'
            value={question?.subject || ''}
            readOnly
            style={inputStyle}
          />
        </FormGroup>

        <FormGroup>
          <Label style={{ color: '#fff' }}>Topic</Label>
          <Input
            type='text'
            value={question?.topic || ''}
            readOnly
            className={question.questionLanguages.includes('fganh') || question.questionLanguages.includes('हिंदी') ? 'hinditext' : ''}
            style={inputStyle}
          />
        </FormGroup>

        <FormGroup>
          <Label style={{ color: '#fff' }}>Languages</Label>
          <Input
            type='text'
            value={question?.questionLanguages?.join(', ') || ''}
            readOnly
            className={question.questionLanguages.includes('fganh') || question.questionLanguages.includes('हिंदी') ? 'hinditext' : ''}
            style={inputStyle}
          />
        </FormGroup>

        <FormGroup>
          <Label style={{ color: '#fff' }}>Question</Label>
          <Input
            type='text'
            value={question?.question || ''}
            readOnly
            className={question.questionLanguages.includes('fganh') || question.questionLanguages.includes('हिंदी') ? 'hinditext' : ''}
            style={inputStyle}
          />
        </FormGroup>
        {/* Upload Image for Question */}
        <FormGroup>
          <Label style={{ color: '#fff' }}>Upload Image for Question</Label>
          <div
            className='uploadFileContainer'
            style={{ textAlign: 'center', minHeight: '150px' }}
          >
            {!questionImage && (
              <>
                <IconButton
                  onClick={() => questionBrowseBtnRef.current.click()}
                >
                  <BackupIcon style={{ fontSize: 70, color: '#007bff' }} />
                </IconButton>
                <Typography
                  variant='subtitle1'
                  style={{ fontWeight: 'normal', margin: '10px 0' }}
                >
                  {questionImage
                    ? 'Image Uploaded'
                    : 'Click here to browse image'}
                </Typography>
                <input
                  type='file'
                  accept='image/*'
                  ref={questionBrowseBtnRef}
                  style={{ display: 'none' }}
                  onChange={handleQuestionImageUpload}
                />
              </>
            )}

            {questionImage && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                }}
              >
                <img
                  src={questionImage}
                  alt='Question'
                  style={{
                    width: '100px',
                    marginTop: '10px',
                    cursor: 'pointer',
                    borderRadius: '8px',
                  }}
                />
                <IconButton
                  onClick={handleRemoveQuestionImage}
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    color: 'red',
                  }}
                >
                  <CancelIcon />
                </IconButton>
              </div>
            )}
          </div>
        </FormGroup>

        {/* Display Options with Image Upload */}
        {['A', 'B', 'C', 'D'].map((key) => (
          <FormGroup key={key}>
            <Label style={{ color: '#fff' }}>
              Option {key}{' '}
              {question?.correctOption === key.toLowerCase() &&
                '(✔ Correct Answer)'}
            </Label>
            <Input
              type='text'
              value={question?.[`option${key}`] || ''}
              readOnly
              style={inputStyle}
            />

            {/* Upload Image for Option */}
            <div
              className='uploadFileContainer'
              style={{ textAlign: 'center', minHeight: '150px' }}
            >
              {!optionImages[`option${key}`] && (
                <>
                  <IconButton
                    onClick={() => secondaryBrowseBtnRef.current[key].click()}
                  >
                    <BackupIcon style={{ fontSize: 70, color: '#007bff' }} />
                  </IconButton>
                  <Typography
                    variant='subtitle1'
                    style={{ fontWeight: 'normal', margin: '10px 0' }}
                  >
                    {optionImages[`option${key}`]
                      ? 'Image Uploaded'
                      : 'Click here to browse image'}
                  </Typography>
                  <input
                    type='file'
                    accept='image/*'
                    ref={(el) => (secondaryBrowseBtnRef.current[key] = el)}
                    style={{ display: 'none' }}
                    onChange={(e) => handleImageUpload(e, `option${key}`)}
                  />
                </>
              )}

              {optionImages[`option${key}`] && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    position: 'relative',
                  }}
                >
                  <img
                    src={optionImages[`option${key}`]}
                    alt={`Option ${key}`}
                    style={{
                      width: '100px',
                      marginTop: '10px',
                      cursor: 'pointer',
                      borderRadius: '8px',
                    }}
                  />
                  <IconButton
                    onClick={() => handleRemoveImage(`option${key}`)}
                    style={{
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      color: 'red',
                    }}
                  >
                    <CancelIcon />
                  </IconButton>
                </div>
              )}
            </div>
          </FormGroup>
        ))}

        {/* Display Error Message */}
        {imageError && (
          <div style={{ color: 'red', textAlign: 'center', marginTop: '10px' }}>
            {imageError}
          </div>
        )}
      </ModalBody>

      <ModalFooter
        style={{
          backgroundColor: 'rgb(39, 41, 61)',
          display: 'flex',
          justifyContent: 'end',
          paddingTop: '12px',
          gap: '12px',
        }}
      >
        <Button color='secondary' onClick={toggleModal}>
          Close
        </Button>
        <Button
          color='info'
          onClick={() => {
            handleSubmit(question?.id);
          }}
        >
          Submit
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ViewQuestionModal;
